export default __webpack_public_path__ + "static/media/logo.db82e8d2.svg";